import { Flex, Box, Spacer, Link, Button } from "@chakra-ui/react";
import { ethers } from "ethers";
import { accContext } from "../context/UserContext";
import { useContext } from "react";
function Nav() {
  const ctx = useContext(accContext);
  const accountAddress = ctx.sharedData.acclogin.accountAddress;
  const connectWallet = async () => {
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const provider = new ethers.providers.Web3Provider(window.ethereum);

    const signer = provider.getSigner();
    ctx.sharedData.addData(provider, signer, accounts[0]);
    // const balance = await signer.getBalance();
    // console.log(`Account balance: ${ethers.utils.formatEther(balance)}`);
  };
  return (
    <Flex alignItems="center" px={4} py={2} bg="#242424" color="white">
      <Box>
        <Link href="/">FlowAlert</Link>
      </Box>
      <Spacer />
      <Box>
        <Link href="/about" marginLeft={4}>
          About
        </Link>
        <Link href="/contact" marginLeft={4}>
          Contact
        </Link>
        <Button
          colorScheme="teal"
          ml={4}
          style={{
            background: "linear-gradient(45deg, #F27121, #E94057, #8A2387)",
          }}
          onClick={connectWallet}
        >
          {" "}
          {accountAddress
            ? `${accountAddress.substr(0, 5)}...${accountAddress.substr(
                37,
                42
              )}`
            : "connect"}
        </Button>
      </Box>
    </Flex>
  );
}

export default Nav;
